"use strict";

module.exports = function (accumulator, order, product, component, options) {
  var linePriceOptions = options.linePrice;
  var place_card_style = component.place_card_style;
  var linePrice = linePriceOptions[place_card_style];
  var running = parseFloat(accumulator, 10) || 0;
  return running + linePrice;
};